import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpClient } from '@angular/common/http';
import { SchoolServices } from '../services';
import { StudentsCreatePage } from '../students-create/students-create';
import { StudentsViewPage } from '../students-view/students-view';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DishListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-students-list',
  templateUrl: 'students-list.html',
})
export class StudentsListPage {
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public http: HttpClient,
    public schoolServices: SchoolServices,
    public translate: TranslateService) {

  }

  async ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-alumnos')
    });
    loadingPopup.present();
    this.schoolServices.getStudents(this.globals.school_uid);
    loadingPopup.dismiss();

  }

  onBack() {
    this.navCtrl.pop();
  }

  openStudentCreate() {
    this.navCtrl.push(StudentsCreatePage);
  }

  openStudent(student) {
    this.navCtrl.push(StudentsViewPage, {
      student: student
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/schools/students-list/students-list.ts